module.exports = __webpack_public_path__ + "static/media/preview-thumbnail-10.ae191bed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pseudodocs/preview-thumbnail-10.jpg
// module id = 1896
// module chunks = 2